export default __webpack_public_path__ + "static/media/Wildclaw Gauntlets.1224fa23.jpg";